// Read-only avatar stack: up to three avatars plus a "+N" bubble.
//
// Eigene Datei (nicht in AssigneePicker), weil die reine Anzeige in Listen- und
// Schritt-Zeilen liegt, die den interaktiven Picker nicht brauchen — der zieht
// den Nutzer-/Mitglieder-Store und lib/auth in den Modulgraphen jedes
// Konsumenten. AssigneePicker re-exportiert AvatarStack weiterhin, damit
// bestehende Importe unverändert funktionieren.

import { findUser } from "../store/users";
import { UserAvatar } from "./UserAvatar";
import type { UserPublic } from "@juuplan/shared";

/** Helper for views that only render the avatar stack (not interactive). */
export function AvatarStack(props: {
  userIds: number[];
  size?: "sm" | "md";
}): preact.JSX.Element | null {
  const { userIds, size = "sm" } = props;
  const px = size === "md" ? 24 : 20;
  const fontSize = `${Math.max(11, Math.round(px * 0.45))}px`;
  const assigned = userIds
    .map((id) => findUser(id))
    .filter((u): u is UserPublic => u !== null);
  if (assigned.length === 0) return null;
  const extra = Math.max(0, assigned.length - 3);
  return (
    // Keine Ueberlappung mehr (Redesign 2026-10): mit der breiteren Systemschrift
    // verdeckte jede Ueberlappung den zweiten Buchstaben ("MD" las sich "MC").
    // Frueher: -space-x-1.5; bei 20px verdeckte der Nachbar sonst den zweiten
    // Buchstaben der Initialen ("AW" las sich als "A").
    <span class="flex shrink-0 gap-0.5">
      {assigned.slice(0, 3).map((u) => (
        <UserAvatar
          key={u.id}
          userId={u.id}
          size={px}
          className="border-2 border-[color:var(--color-surface-container-lowest)]"
        />
      ))}
      {extra > 0 && (
        <span
          class="shrink-0 rounded-full bg-[color:var(--color-surface-container-high)] font-semibold flex items-center justify-center border-2 border-[color:var(--color-surface-container-lowest)] text-[color:var(--color-on-surface-variant)]"
          style={{ width: `${px}px`, height: `${px}px`, fontSize }}
          role="img"
          title={assigned.slice(3).map((u) => u.name).join(", ")}
          aria-label={`${extra} weitere: ${assigned.slice(3).map((u) => u.name).join(", ")}`}
        >
          +{extra}
        </span>
      )}
    </span>
  );
}
